import React from "react";
import SVG from "react-inlinesvg";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faWifi, faCoins, faUtensils } from "@fortawesome/fontawesome-pro-light";

import roomFeatureArea from "../../images/room-feature-area.svg";
import roomFeatureGuests from "../../images/room-feature-guests.svg";
import roomFeatureBeds from "../../images/room-feature-beds.svg";
import roomFeatureBalcony from "../../images/room-feature-balcony.svg";
import T from "../Translate";
import BedConfig from "../../enums/BedConfig";
import BoardBaseEnum from "../../enums/BoardBase";
import {getDefaultBoardBase, isPricelistFeesIncluded} from "../../apiHelpers";
import withLocalize from '../../withLocalize';

export const RoomOfferAttributes = withLocalize(({ roomOffer, pricelistFees, boardBases, translate: t }) => {

	const defaultBoardBaseId = getDefaultBoardBase(boardBases);

	return (
		<ul className="room-offer-features">
			{roomOffer.attributes.size !== 0 &&
			<li className="room-offer-features__item">
				<SVG src={roomFeatureArea}/>
				<span className="room-offer-features__text">{roomOffer.attributes.size} m<sup>2</sup></span>
			</li>
			}
			<li className="room-offer-features__item room-offer-features__item-beds">
				<SVG src={roomFeatureGuests}/>
				<span className="room-offer-features__text">
					<T id="Rooms.RoomOffer.max"/> {roomOffer.beds}
					{roomOffer.extrabeds > 0 && <span> + {roomOffer.extrabeds}</span>}
				</span>
			</li>
			{roomOffer.bedConfig !== null &&
			<li className="room-offer-features__item room-offer-features__item-bed-config">
				<SVG src={roomFeatureBeds}/>
				<span className="room-offer-features__text">{t(BedConfig.getLabel(roomOffer.bedConfig))}</span>
			</li>
			}
			{roomOffer.attributes.wifi !== 0 &&
			<li className="room-offer-features__item">
				<FontAwesomeIcon icon={faWifi} className="fa-padding-right"/>
				<span className="room-offer-features__text"><T id="Rooms.RoomOffer.wifi"/></span>
			</li>
			}
			{roomOffer.attributes.balcony !== 0 &&
			<li className="room-offer-features__item">
				<SVG src={roomFeatureBalcony}/>
				<span className="room-offer-features__text"><T id="Rooms.RoomOffer.balcony"/></span>
			</li>
			}
			{defaultBoardBaseId !== null && boardBases[defaultBoardBaseId].priceIncluded === 1 &&
			boardBases[defaultBoardBaseId].id !== BoardBaseEnum.WITHOUT &&
			<li className="room-offer-features__item">
				<FontAwesomeIcon icon={faUtensils} className="fa-margin-right"/>
				<span className="room-offer-features__text">{boardBases[defaultBoardBaseId].name} <T
					id="Rooms.RoomOffer.priceIncluded"/></span>
			</li>
			}
			{Object.keys(pricelistFees).length > 0 && isPricelistFeesIncluded(pricelistFees) &&
			<li className="room-offer-features__item">
				<FontAwesomeIcon icon={faCoins} className="fa-margin-right"/>
				<span className="room-offer-features__text"><T id="Rooms.RoomOffer.fees"/> <T
					id="Rooms.RoomOffer.priceIncluded"/></span>
			</li>
			}
		</ul>
	);
});



// WEBPACK FOOTER //
// ./src/components/Rooms/RoomOfferAttributes.jsx